/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  function reorderComparePrice(root = document) {
    root.querySelectorAll('.btn__price').forEach(function(el) {
      const s = el.querySelector('s')
      if (!s) return

      const compareHtml = s.outerHTML
      const salePrice = el.textContent.replace(s.textContent, '').trim()
      const desiredHtml = compareHtml + ' ' + salePrice

      if (el.innerHTML.trim() === desiredHtml) return

      el.innerHTML = desiredHtml
    })
  }

  let observer

  function observe() {
    observer = new MutationObserver(function() {
      observer.disconnect()
      reorderComparePrice()
      observe()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  }

  document.addEventListener('DOMContentLoaded', function() {
    reorderComparePrice()
    observe()
  })




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
